import React, { useEffect, useState } from 'react';

import {
    PatientDetails,
} from '../../components/common/patientDetails';

import {
    clearData,
    flexiDeliverRemovingPageNumber,
    fetchFlexiDeliver
} from '../../services/slices/dispense/flexiDeliver';

import { onhandleConfirmDelivery } from '../../utils/helper/deliveriesHelper'
import { handleToggleRXData } from '../../utils/helper/helper';
import { useAuthSelector } from '../../services/selectors/authSelector';
import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';
import { useCustomStates } from '../../hooks/useCustomStates';
import { DispenseRxData } from '../../components/common/dispenseRxData';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
// import { MissedDeliveryConfirmation } from '../../components/common/routeConfirmation';
import { RxStatusWarningModal } from '../../components/common/rxStatusWarningModal';
import { PharmacistConfirmationModal } from '../../components/common/routeConfirmation';
import { clearSelectedPharmacistID } from '../../services/slices/auth/selectedPharmacist';
import { PharmacistSelection } from '../../components/common/pharmacistSelection';

import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';
import PageNotFound from '../notFound/pageNotFound';

import * as routeNames from '../../routes/routeName'
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as Loading from '../../components/common/loader'
import * as Messages from '../../components/common/AllConfirmationMessages'

const Flexi_delivery = () => {

    const dispatch = Hooks.useCustomDispatch();
    const navigate = Hooks.useCustomNavigate();

    const { pharmacyId, pharmacyInspectionMode, selectedPharmacistID } = useAuthSelector()

    const { flexiDeliverResponse,
        validateReturnedPatchesResponse,
        pharmacistDetail,
    } = useAllSelector();

    const { comment,
        setComment,

        cordinate,
        setCordinate,

        isRefused,
        setIsRefused,

        openIndex,
        setOpenIndex,

        patientSignature,
        setPatientSignature,

        pharmacistSignature,
        setPharmacistSignature,

        showErrorToast,
        setShowErrorToast,

        loading,
        setLoading,

        showSuccessToast,
        setShowSuccessToast,

        showComment,
        setShowComment,

        showPatientSignature,
        setShowPatientSignature,

        showPharmacistSignature,
        setShowPharmacistSignature,

        showData,
        setShowData,

        apiCallMade,
        setApiCallMade,

        signatureErrors,
        setSignatureErrors,

        covid19,
        setCovid19,

        isTransferRequest,
        setIsTransferRequest,

        loadMore,
        setLoadMore,
        patientId,
        setPatientID,

        pId,
        setPId,

        consultation,
        setConsultation,

        newRxCounsellingValues,
        setNewRxCounsellingValues,

        isPatientVerified,
        setIsPatientVerified,

        selectedDoses,
        setSelectedDoses
    } = useCustomStates()

    // RX Status Warning Modal States
    const [showRxStatusWarning, setShowRxStatusWarning] = useState(false);
    const [rxStatusData, setRxStatusData] = useState([]);
    const [pendingDeliveryData, setPendingDeliveryData] = useState(null);
    const [pendingDeliveryIndex, setPendingDeliveryIndex] = useState(null);

    // Pharmacist Confirmation Modal States
    const [showPharmacistConfirmation, setShowPharmacistConfirmation] = useState(false);
    const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([]);
    const [flexiProofImages, setFlexiProofImages] = useState({});
    const [copayPaymentOptions, setCopayPaymentOptions] = useState({});

    // Get Selected Pharmacist Name
    const getSelectedPharmacistName = () => {
        if (selectedPharmacistID && pharmacistDetail?.length) {
            const selectedPharmacist = pharmacistDetail.find(
                pharmacist => Number(pharmacist.id) === Number(selectedPharmacistID) || pharmacist.id == selectedPharmacistID
            );
            return selectedPharmacist?.name || '';
        }
        return '';
    };

    const handleDropdownToggle = (index, data) => {
        setConsultation(null)
        setNewRxCounsellingValues([])
        setSelectedDoses({})
        if (openIndex !== index) {
            const rxIds = data?.patients_win_rx_data?.map((r) => r.id).filter(Boolean) || []
            setSelectedDeliverRxIds(rxIds)
        }
        handleToggleRXData(
            index,
            data,
            openIndex,
            setOpenIndex,
            dispatch,
            clearSelectedPharmacistID,
            setSignatureErrors,
            setShowData,
            RemoveAllPatchesId,
            setPatientSignature,
            setShowComment,
            setShowPatientSignature,
            setShowPharmacistSignature,
            setPharmacistSignature,
            setComment,
            setIsPatientVerified,
            setPId,
            pharmacyId
        )
        handleWarningCancel()
    }

    useEffect(() => {
        if (pharmacyId) {
            setLoading(true)
            if (!apiCallMade) {
                dispatch(clearData())
                dispatch(flexiDeliverRemovingPageNumber())
                dispatch(fetchFlexiDeliver({
                    page: 1,
                    pharmacy_id: pharmacyId,
                    setLoading: setLoading
                }))
                setApiCallMade(true)
            }
        }
        return () => { }
    }, [])

    // Function to check for RX status warnings
    const checkRxStatus = (patientData) => {

        const warningRxs = [];

        if (patientData?.patients_win_rx_data.length > 0) {
            // Debug: Log the first RX to see available fields

            patientData?.patients_win_rx_data.forEach(rx => {
                // Check for various possible status fields that might contain 'S' (Stopped) or 'Tsf' (Transferred)
                const statusFields = [rx?.pharmacyWinrxRxEs?.rxstat];

                const hasWarningStatus = statusFields.some(status =>
                    status === 'S' || status === 'Tsf' || status === 's' || status === 'tsf'
                );

                if (hasWarningStatus) {
                    warningRxs.push({
                        rxnumber: rx.rxnumber,
                    });
                }
            });
        }

        return warningRxs;
    };

    const handleConfirmDelivery = (patientData, index) => {
        // if (!isRefused && (!patientSignature || patientSignature[0] == null)) {
        //     setSignatureErrors(prevState => ({ ...prevState, patientSign: '1px solid red' }));
        //     return;
        // }
        setPendingDeliveryData(patientData);
        setPendingDeliveryIndex(index);
        // Only show Confirm Pharmacist popup when there is a pharmacist signature on the pad
        if (pharmacistSignature) {
            setShowPharmacistConfirmation(true);
        } else {
            // No pharmacist sign – continue delivery without showing the modal
            const warningRxs = checkRxStatus(patientData);
            if (warningRxs.length > 0) {
                setRxStatusData(warningRxs);
                setShowRxStatusWarning(true);
            } else {
                proceedWithDelivery(patientData, index);
            }
        }
    };

    const handlePharmacistConfirmationConfirm = () => {
        setShowPharmacistConfirmation(false);
        
        if (pendingDeliveryData && pendingDeliveryIndex !== null) {
            // Check for RX status warnings after pharmacist confirmation
            const warningRxs = checkRxStatus(pendingDeliveryData);

            if (warningRxs.length > 0) {
                // Show warning modal
                setRxStatusData(warningRxs);
                setShowRxStatusWarning(true);
            } else {
                // Proceed with normal delivery
                proceedWithDelivery(pendingDeliveryData, pendingDeliveryIndex);
            }
        }
    };

    const handlePharmacistConfirmationCancel = () => {
        setShowPharmacistConfirmation(false);
        setPharmacistSignature(null);
        setPendingDeliveryData(null);
        setPendingDeliveryIndex(null);
    };

    const proceedWithDelivery = (patientData, index) => {
        const rxIdsToSend = selectedDeliverRxIds?.length > 0
            ? selectedDeliverRxIds
            : (patientData?.patients_win_rx_data?.map((r) => r.id).filter(Boolean) || []);
        onhandleConfirmDelivery(patientData,
            index,
            pharmacyId,
            selectedPharmacistID,
            patientSignature,
            pharmacistSignature,
            cordinate,
            comment,
            dispatch,
            setLoading,
            setOpenIndex,
            setShowErrorToast,
            setShowSuccessToast,
            pharmacyInspectionMode,
            isRefused,
            covid19,
            'flexi_deliver',
            setIsRefused,
            setSignatureErrors,
            validateReturnedPatchesResponse,
            isTransferRequest,
            setIsTransferRequest,
            consultation,
            newRxCounsellingValues,
            selectedDoses,
            flexiProofImages,
            copayPaymentOptions,
            null,
            isPatientVerified,
            rxIdsToSend
        );
        handleWarningCancel()
    };

    const handleWarningConfirm = () => {
        setShowRxStatusWarning(false);
        if (pendingDeliveryData && pendingDeliveryIndex !== null) {
            proceedWithDelivery(pendingDeliveryData, pendingDeliveryIndex);
        }
    };

    const handleWarningCancel = () => {
        setShowRxStatusWarning(false);
        setRxStatusData([]);
        setPendingDeliveryData(null);
        setPendingDeliveryIndex(null);
    };

    const fetchMoreData = () => {
        if (flexiDeliverResponse?.currentPage < flexiDeliverResponse?.totalPages) {
            setLoadMore(true)
            dispatch(fetchFlexiDeliver({
                page: flexiDeliverResponse?.currentPage + 1,
                pharmacy_id: pharmacyId,
                setLoading: setLoading,
                setLoadMore: setLoadMore
            }))
        }
    }

    return (
        <>
            {pharmacyId ? <>
                {flexiDeliverResponse?.data?.length > 0 &&
                    <InfiniteScroll
                        dataLength={flexiDeliverResponse?.data?.length}
                        next={fetchMoreData}
                        hasMore={flexiDeliverResponse?.currentPage <= flexiDeliverResponse?.totalPages}
                    />
                }

                <div className="app-wrapper flex justify-center">
                    <div className="app-screen no-shades w-full h-full overflow-x-hidden">
                        <div className="relative p-4">
                            <div className="card bg-white p-4 rounded-lg shadow-sm">
                                <div className="flex items-center justify-between gap-3">
                                    <div>
                                        <Common.TopBar pharmacyId={pharmacyId} />
                                    </div>
                                    <div className='flex items-center justify-center btnnn pt-4' onClick={() => navigate(`${routeNames.DASHBOARD_PHARMACY}`)} >
                                        <Icons.HomeIcon />
                                    </div>
                                </div>
                            </div>

                            <div className="title-row my-2">
                                <h1 className="text-xl font-bold">Flexi Deliver</h1>
                            </div>

                            <div className="flex gap-3 mb-3">
                                <SearchBox pharmacyId={pharmacyId} />
                            </div>

                            <div className="routes-list">
                                {(flexiDeliverResponse?.loading && loading) ?
                                    <div className='flex justify-center pb-4 h-96'>
                                        <Loading.LoadingView />
                                    </div> :

                                    flexiDeliverResponse?.error !== null ?
                                        <div className='flex justify-center pb-4 mb-4 h-96'>
                                            <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                                        </div> :

                                        (flexiDeliverResponse?.data?.length === 0 && !flexiDeliverResponse?.loading) ?
                                            <p className='flex justify-center pb-4 h-96'>No more deliveries for today.</p>
                                            :

                                            flexiDeliverResponse?.data?.map((data, index) => {
                                                const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
                                                            <PatientDetails
                                                                data={data}
                                                                patientImg={data.profile_image}
                                                                totalRxData={data?.patients_win_rx_data?.length}
                                                                index={index}
                                                                openIndex={openIndex}
                                                                onDropdownToggle={handleDropdownToggle}
                                                            >
                                                                <>
                                                                    <DispenseRxData
                                                                        rxData={data?.patients_win_rx_data}
                                                                        signatureErrors={signatureErrors}
                                                                        type="new_rx"
                                                                        newRxCounsellingValues={newRxCounsellingValues}
                                                                        setNewRxCounsellingValues={setNewRxCounsellingValues}
                                                                        patientData={data}
                                                                        selectedDoses={selectedDoses}
                                                                        setSelectedDoses={setSelectedDoses}
                                                                        hideFlexi={false}
                                                                        flexiProofImages={flexiProofImages}
                                                                        setFlexiProofImages={setFlexiProofImages}
                                                                        copayPaymentOptions={copayPaymentOptions}
                                                                        setCopayPaymentOptions={setCopayPaymentOptions}
                                                                        selectedDeliverRxIds={selectedDeliverRxIds}
                                                                        setSelectedDeliverRxIds={setSelectedDeliverRxIds}
                                                                        isActiveDeliverRxCard={openIndex === index}
                                                                    />

                                                                    {patientId !== data?.id ? <>
                                                                        <PharmacistSelection
                                                                            signatureErrors={signatureErrors}
                                                                            setSignatureErrors={setSignatureErrors}
                                                                            setShowData={setShowData}
                                                                        />

                                                                        {showData &&
                                                                            <React.Fragment>
                                                                                <div className="mb-3">
                                                                                    <Common.DeliveryConsultationDropdown consultation={consultation}
                                                                                        setConsultation={setConsultation} />
                                                                                </div>
																				<div className="flex flex-col md:flex-row gap-3 mb-3 items-start">
                                                                                    <Common.PatientSignature patientSignature={patientSignature}
                                                                                        setPatientSignature={setPatientSignature}
                                                                                        showPatientSignature={showPatientSignature}
                                                                                        setShowPatientSignature={setShowPatientSignature}
                                                                                        isRefused={isRefused}
                                                                                        setIsRefused={setIsRefused}
                                                                                        signatureErrors={signatureErrors}
                                                                                        setSignatureErrors={setSignatureErrors}
                                                                                        covid19={covid19}
                                                                                        setCovid19={setCovid19}
                                                                                        rxData={data?.patients_win_rx_data}
                                                                                    />
                                                                                    <Common.PharmacistSignature
                                                                                        pharmacistSignature={pharmacistSignature}
                                                                                        setPharmacistSignature={setPharmacistSignature}
                                                                                        showPharmacistSignature={showPharmacistSignature}
                                                                                        setShowPharmacistSignature={setShowPharmacistSignature}
                                                                                        signatureErrors={signatureErrors}
                                                                                        setSignatureErrors={setSignatureErrors}
                                                                                        selectedPharmacistID={selectedPharmacistID}
                                                                                        pharmacistDetail={pharmacistDetail}
                                                                                    />
                                                                                </div>
                                                                                <Common.Comment showComment={showComment}
                                                                                    setShowComment={setShowComment}
                                                                                    setComment={setComment} comment={comment} />
                                                                                <Common.PatientVerified
                                                                                    isPatientVerified={isPatientVerified}
                                                                                    setIsPatientVerified={setIsPatientVerified}
                                                                                />
                                                                            </React.Fragment>
                                                                        }

                                                                        {selectedPharmacistID && (
                                                                        <div className="flex items-center gap-3">
                                                                            {showData ?
                                                                                validateReturnedPatchesResponse?.loading ? null :
                                                                                    <button
                                                                                        className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
                                                                                        style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
                                                                                        disabled={noRxSelected}
                                                                                        onClick={() => {
                                                                                            if (noRxSelected) return;
                                                                                            handleConfirmDelivery(data, index);
                                                                                        }}
                                                                                    >
                                                                                        Continue
                                                                                    </button>
                                                                                :
                                                                                    <button
                                                                                        className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
                                                                                        style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
                                                                                        disabled={noRxSelected}
                                                                                        onClick={() => {
                                                                                            if (noRxSelected) return;
                                                                                            setShowData(true);
                                                                                            setTimeout(() => {
                                                                                                const windowHeight = window.innerHeight;
                                                                                                const scrollAmount = windowHeight / 2;
                                                                                                window.scrollBy({ top: scrollAmount, behavior: "smooth" });
                                                                                            }, 100);
                                                                                        }}
                                                                                    >
                                                                                        Deliver
                                                                                    </button>
                                                                            }
                                                                        </div>
                                                                        )}

                                                                    </> : null}
                                                                </>
                                                            </PatientDetails>
                                                        </div>
                                                    </React.Fragment>);
                                            })}
                            </div>

                            {loadMore &&
                                <div className='flex mb-2'>
                                    <div className="loaderss"></div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {showErrorToast && <Messages.DeliveryErrorMessages setShowErrorToast={setShowErrorToast} message={typeof showErrorToast === 'string' ? showErrorToast : undefined} />}
                {showSuccessToast && <Messages.DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}

                <RxStatusWarningModal
                    showModal={showRxStatusWarning}
                    setShowModal={setShowRxStatusWarning}
                    onConfirm={handleWarningConfirm}
                    onCancel={handleWarningCancel}
                    rxStatusData={rxStatusData}
                />

                <PharmacistConfirmationModal
                    showModal={showPharmacistConfirmation}
                    setShowModal={setShowPharmacistConfirmation}
                    pharmacistName={getSelectedPharmacistName()}
                    onConfirm={handlePharmacistConfirmationConfirm}
                    onCancel={handlePharmacistConfirmationCancel}
                />

            </>
                : <PageNotFound />}
        </>
    )
}

export default Flexi_delivery
